import React, { useState, useEffect } from "react";
import { findObjectUseCase, saveObjectUseCase } from "../../usecases/object";
import { saveFileUseCase, saveImageUseCase } from "../../usecases/file";
import Context from "../../AppContext";
import InputFactory from "../InputFactory";
import { FormFactory as Factory } from "../../nq-component";

function filterSchemaFieldsByVisibility(schema, object) {
  const filteredSchema = JSON.parse(JSON.stringify(schema));
  if (!filteredSchema.fields) return filteredSchema;

  for (const [key, field] of Object.entries(filteredSchema.fields)) {
    const condition = field.visibleIf;
    if (condition) {
      for (const [condKey, condValue] of Object.entries(condition)) {
        if (object?.[condKey] !== condValue) {
          delete filteredSchema.fields[key];
        }
      }
    }
  }

  return filteredSchema;
}

function FormFactory({
  age,
  schema,
  object,
  onChange,
  excludeFields,
  ...props
}) {
  const context = React.useContext(Context);

  const [formState, setFormState] = useState({
    ...object,
    isUntilPresent: object?.isUntilPresent ?? false,
    isUntilPresentCol: object?.isUntilPresentCol ?? false,
    isUntilPresentEmployment: object?.isUntilPresentEmployment ?? false,
  });

  const handleChange = (value, field) => {
    const updated = { ...formState, [field]: value };
    setFormState(updated);
    onChange(value, field);
  };

  const visibleSchema = filterSchemaFieldsByVisibility(schema, formState);

  return schema.birthDate ? (
    <p className="bg-light-subtle p-2 cursor-pointer text-center fw-bold">
      {age}
    </p>
  ) : (
    <Factory
      className="col-md-4 col-lg-12"
      schema={visibleSchema}
      schemas={context.schemas}
      object={object}
      onChange={handleChange}
      excludeFields={excludeFields}
      findObject={findObjectUseCase()}
      saveObject={saveObjectUseCase()}
      saveImage={saveImageUseCase()}
      saveFile={saveFileUseCase()}
      componentFactory={InputFactory}
      {...props}
    />
  );
}

export default FormFactory;
